import privateAxiosInstance from "../utils/axios/private";
import { hybridEncrypt, hybridDecrypt } from "../utils/crypto";

export const subscriptionApi = {
  /**
   * Create Subscription Plan
   * Endpoint: /subscription/plans/
   * Method: POST
   */
  async createPlan(payload) {
    try {
      const encryptedPayload = await hybridEncrypt(payload);
      const response = await privateAxiosInstance.post(
        "/subscription/create/",
        payload
      );
      if (response.data.encrypted) {
        return await hybridDecrypt(response.data);
      }
      return response.data;
    } catch (error) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 0,
          data: "Network_error",
          message: "Network error. Please check your internet connection.",
          type: "network_error",
        };
      }
      return error.response?.data || {
        status: 500,
        message: "Error creating subscription plan",
      };
    }
  },

  async createOrder(payload) {
    try {
      const response = await privateAxiosInstance.post(
        "/payments/order/",
        payload
      );
      if (response.data.encrypted) {
        return await hybridDecrypt(response.data);
      }
      return response.data;
    } catch (error) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 0,
          data: "Network_error",
          message: "Network error. Please check you internet connection.",
          type: "network_error",
        };
      }
      return error.response?.data || {
        status: 500,
        message: "Error creating Razorpay order",
      };
    }
  },

  async verifyPayment(payload) {
    try {
      const response = await privateAxiosInstance.post(
        "/payments/verify/",
        payload
      );
      if (response.data.encrypted) {
        return await hybridDecrypt(response.data);
      }
      return response.data;
    } catch (error) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 0,
          data: "Network_error",
          message: "Network error. Please check your internet connection.",
          type: "network_error",
        };
      }
      return error.response?.data || {
        status: 500,
        message: "Error verifying payment",
      };
    }
  },

  /**
   * Get All Subscription Plans
   * Endpoint: /subscription/plans/
   * Method: GET
   */

    async getRegistrationPlan() {
    try {
      const response = await privateAxiosInstance.get("/subscription/registration-plan/");
      if (response.data.encrypted) {
        return await hybridDecrypt(response.data);
      }
      return response.data;
    } catch (error) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 0,
          data: "Network_error",
          message: "Network error. Please check your internet connection.",
          type: "network_error",
        };
      }
      return error.response?.data || {
        status: 500,
        message: "Error fetching subscription plans",
      };
    }
  },

  async getPlans(payload) {
    try {
      const response = await privateAxiosInstance.get("/subscription/plans/", { params: payload });
      if (response.data.encrypted) {
        return await hybridDecrypt(response.data);
      }
      return response.data;
    } catch (error) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 0,
          data: "Network_error",
          message: "Network error. Please check your internet connection.",
          type: "network_error",
        };
      }
      return error.response?.data || {
        status: 500,
        message: "Error fetching subscription plans",
      };
    }
  },

  /**
   * Get Single Subscription Plan
   * Endpoint: /subscription/plans/:id/
   * Method: GET
   */
  async getPlan(plan_id) {
    try {
      const response = await privateAxiosInstance.get(
        `/subscription/plan//${plan_id}/`
      );
      if (response.data.encrypted) {
        return await hybridDecrypt(response.data);
      }
      return response.data;
    } catch (error) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 0,
          data: "Network_error",
          message: "Network error. Please check your internet connection.",
          type: "network_error",
        };
      }
      return error.response?.data || {
        status: 500,
        message: "Error fetching subscription plan",
      };
    }
  },

  /**
   * Update Subscription Plan
   * Endpoint: /subscription/plans/:id/
   * Method: PUT
   */
  async updatePlan(plan_id, payload) {
    try {
      const encryptedPayload = await hybridEncrypt(payload);
      const response = await privateAxiosInstance.put(
        `/subscription/plan/${plan_id}/`,
        payload
      );
      if (response.data.encrypted) {
        return await hybridDecrypt(response.data);
      }
      return response.data;
    } catch (error) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 0,
          data: "Network_error",
          message: "Network error. Please check your internet connection.",
          type: "network_error",
        };
      }
      return error.response?.data || {
        status: 500,
        message: "Error updating subscription plan",
      };
    }
  },


  async planChangeRequest(plan_id) {
    try {
      const response = await privateAxiosInstance.put(
        `/subscription/plan-upgrade/`,
        { "plan_id": plan_id }

      );
      if (response.data.encrypted) {
        return await hybridDecrypt(response.data);
      }
      return response.data;
    } catch (error) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 0,
          data: "Network_error",
          message: "Network error. Please check your internet connection.",
          type: "network_error",
        };
      }
      return error.response?.data || {
        status: 500,
        message: "Error updating subscription plan",
      };
    }
  },

  /**
   * Delete Subscription Plan
   * Endpoint: /subscription/plans/:id/
   * Method: DELETE
   */
  async deletePlan(plan_id) {
    try {
      const response = await privateAxiosInstance.delete(
        `/subscription/plan/${plan_id}/`
      );
      if (response.data.encrypted) {
        return await hybridDecrypt(response.data);
      }
      return response.data;
    } catch (error) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 0,
          data: "Network_error",
          message: "Network error. Please check your internet connection.",
          type: "network_error",
        };
      }
      return error.response?.data || {
        status: 500,
        message: "Error deleting subscription plan",
      };
    }
  },


  /**
 * Get Tenant Subscription Details
 * Endpoint: /tenant/subscription/
 * Method: GET
 */
  async getTenantPlan() {
    try {
      const response = await privateAxiosInstance.get("/subscription/plan-tenant/");
      if (response.data.encrypted) {
        return await hybridDecrypt(response.data);
      }
      return response.data;
    } catch (error) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 0,
          data: "Network_error",
          message: "Network error. Please check your internet connection or try again later.",
          type: "network_error",
        }
      }
      return error.response?.data || { status: 404, message: "Subscription details not found" };
    }
  },

  async getPlanForRecruiter() {
    try {
      const response = await privateAxiosInstance.get("/subscription/plan-recruiter/");
      if (response.data.encrypted) {
        return await hybridDecrypt(response.data);
      }
      return response.data;
    } catch (error) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 0,
          data: "Network_error",
          message: "Network error. Please check your internet connection or try again later.",
          type: "network_error",
        }
      }
      return error.response?.data || { status: 404, message: "Subscription details not found" };
    }
  },


  /**
 * Get Token Usage by Process
 * Endpoint: /subscription/token-usage/
 * Method: GET
 * Returns: list of { process_name, tokens_used }
 */
  async getRecruiterTokenUsage() {
    try {
      const response = await privateAxiosInstance.get("/token/recruiter/token-usage/");
      if (response.data.encrypted) {
        return await hybridDecrypt(response.data);
      }
      return response.data;
    } catch (error) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 0,
          data: "Network_error",
          message: "Network error. Please check your internet connection or try again later.",
          type: "network_error",
        };
      }
      return error.response?.data || { status: 500, message: "Error fetching token usage" };
    }
  },

  async getAdminCreditUsage(offset = 0, limit = 10, filters = {}) {
    try {
      const params = {
        offset: offset,
        limit: limit,
        ...filters
      };
      const response = await privateAxiosInstance.get("/subscription/admin/credit-usage/", {
        params
      });
      if (response.data.encrypted) {
        return await hybridDecrypt(response.data);
      }
      return response.data;
    } catch (error) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 0,
          data: "Network_error",
          message: "Network error. Please check your internet connection or try again later.",
          type: "network_error",
        };
      }
      return error.response?.data || { status: 500, message: "Error fetching token usage" };
    }
  },

  /**
   * Get Purchase History (Admin)
   * Endpoint: /subscription/admin/purchase-history/
   * Method: GET
   */
  async getPurchaseHistory(offset = 0, limit = 10, filters = {}) {
    try {
      const params = {
        offset: offset,
        limit: limit,
        ...filters
      };
      const response = await privateAxiosInstance.get("/subscription/admin/purchase-history/", {
        params
      });
      if (response.data.encrypted) {
        return await hybridDecrypt(response.data);
      }
      return response.data;
    } catch (error) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 0,
          data: "Network_error",
          message: "Network error. Please check your internet connection or try again later.",
          type: "network_error",
        };
      }
      return error.response?.data || { status: 500, message: "Error fetching purchase history" };
    }
  },

};
